import { ConnectionNames } from "../Contracts";
import { QGetLastBetAge } from "./Helpers";
import { BaseRESTConnection } from "../Common";
export class CasinoPlayerActivityConnection extends BaseRESTConnection {
    constructor(meta) {
        super(ConnectionNames.casinoPlayerActivity, meta);
    }
    getLastBetAge(platform) {
        return this.applyQuery(QGetLastBetAge(platform));
    }
}
//# sourceMappingURL=CasinoPlayerActivityConnection.js.map